const {AdminInput} = require('../../../../FormInputs');
const React = require('react');

module.exports = ({symbol, className, ...props}) => {
  return (
    <div className="rlv">
      <AdminInput
        className={
          `pt0-i pb0-i
        (hmin35|pv12-i|tc)>.MuiInputBase-input
        (w|tc|xY100%)>.error-display`
          + (className ? ` ${className}` : '')
        }
        name="fee"
        disableLabel
        {...props}
      />
      <div className="w26 abs st50% sr0 xY-50% pv12 f12 o50">
        <span dangerouslySetInnerHTML={{__html: symbol}} />
      </div>
    </div>
  )
}
